import { useProfile } from './useProfile/index.jsx';

export function useIsAgencyCompany() {
  const { getProfileField } = useProfile();

  return Boolean(getProfileField('company')?.agencyCompany);
}
